import { HttpClient } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthServiceService {
  private isBrowser = false;

  // apiUrl = 'https://nexpropel.com/api';
  apiUrl = environment.apiUrl;
  orderEngineUrl = environment.apiUrlOrderEngine;
  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  isLogin(): boolean {
    if (this.isBrowser) {
      return !!localStorage.getItem('token');
    }
    return false;
  }

  logout() {
    if (this.isBrowser) {
      localStorage.clear();
      // localStorage.removeItem('token');
    }
  }

  // Store the token (you can replace this with localStorage or other storage methods)
  getToken(): string {
    if (this.isBrowser) {
      return localStorage.getItem('token') || ''; // Retrieve the token
    }
    return '';
  }

  // Save token to localStorage (optional)
  setToken(token: string): void {
    if (this.isBrowser) {
      localStorage.setItem('token', token);
    }
  }

  sendOtp(data: any) {
    return this.http.post(`${this.apiUrl}/users/sendOtp`, data);
  }

  verifyOtp(data: any) {
    return this.http.post(`${this.apiUrl}/users/verifyOtp`, data);
  }

  signUp(data: any) {
    return this.http.post(`${this.apiUrl}/users/signUp`, data);
  }

  logIn(data: any) {
    return this.http.post(`${this.apiUrl}/users/login`, data);
  }

  getOtpSessionDetails(data: any) {
    return this.http.post(`${this.apiUrl}/users/otp-session-details`, data);
  }

  oAuth(data: any) {
    return this.http.post(`${this.apiUrl}/users/oauth`, data);
  }

  createOrder(data: any) {
    // return this.http.post(`${this.apiUrl}/orders/create-order`, data);
    return this.http.post(`${this.orderEngineUrl}/orders/create-order`, data);
  }

  cancelOrder(data: any) {
    return this.http.post(`${this.orderEngineUrl}/orders/cancel-order`, data);
  }

  updatesltp(data: any) {
    return this.http.post(`${this.orderEngineUrl}/orders/update-sltp`, data);
  }

  getVerificationDetails() {
    return this.http.get(`${this.apiUrl}/users/getVerificationDetails`);
  }

  closeall(data: any) {
    return this.http.post(`${this.orderEngineUrl}/orders/closeall`, data);
  }

  getOrderHistory(data: any) {
    return this.http.get(
      `${this.apiUrl}/orders/getOrderHistory?startDate=${encodeURIComponent(data.startDate)}&endDate=${encodeURIComponent(data.endDate)}&days=${encodeURIComponent(data.days)}`,
    );
  }

  sendForgotPasswordOtp(data: any) {
    return this.http.post(`${this.apiUrl}/users/sendForgotPasswordOtp`, data);
  }

  changePassword(data: any) {
    return this.http.post(`${this.apiUrl}/users/changePassword`, data);
  }

  getAccountDetails() {
    return this.http.get(`${this.apiUrl}/users/getAccountDetails`);
  }

  getPnlReports(filter: any) {
    return this.http.get(
      `${this.apiUrl}/orders/generatePnLData?filter=` + filter,
    );
  }

  getCandleData(
    symbol: string,
    timeFrame: string,
    contractType: string,
    chartType: string,
  ) {
    return this.http.get(
      `${this.apiUrl}/options/getCandleData?symbol=` +
        symbol +
        '&timeStamp=' +
        'IST' +
        '&timeframe=' +
        timeFrame +
        '&contractType=' +
        contractType +
        '&chartType=' +
        chartType,
    );
  }

  getFuturesMarketData(data: any) {
    return this.http.get(
      `${this.apiUrl}/options/getFuturesRates?contractName=` + data,
    );
  }

  getProfileDetails() {
    return this.http.get(`${this.apiUrl}/users/getProfileDetails`);
  }

  getRefferal() {
    return this.http.get(`${this.apiUrl}/users/getRefferal`);
  }

  getRefferalAnalytics() {
    return this.http.get(`${this.apiUrl}/users/getRefferalAnalytics`);
  }

  getSymbols(contractType: any) {
    return this.http.get(
      `${this.apiUrl}/options/getSymbols?contractType=` + contractType,
    );
  }

  changeMarginMode(mode: any) {
    return this.http.post(
      `${this.orderEngineUrl}/orders/change-margin-mode`,
      mode,
    );
  }

  addMoreMargin(data: any) {
    return this.http.post(`${this.orderEngineUrl}/orders/addMoreMargin`, data);
  }

  verifyBank(data: any) {
    return this.http.post(`${this.apiUrl}/kyc/verify`, data);
  }

  checkStatus(requestId: string) {
    return this.http.get(`${this.apiUrl}/kyc/status/${requestId}`);
  }

  withdrawRequest(data: any) {
    return this.http.post(`${this.apiUrl}/users/withdraw-request`, data);
  }

  getAllWithdrawal() {
    return this.http.get(`${this.apiUrl}/users/getWithdrawals`);
  }

  getBankDetails() {
    return this.http.get(`${this.apiUrl}/users/bank-details`);
  }

  getUserBankDetails() {
    return this.http.get(`${this.apiUrl}/users/user-bank-details`);
  }

  getRiskAcceptedStatus() {
    return this.http.get(`${this.apiUrl}/users/risk-discloure`);
  }

  markRiskAccepted() {
    return this.http.post(`${this.apiUrl}/users/mark-risk-accepted`, {});
  }

  getWalletBalance(walletType: any) {
    return this.http.get(
      `${this.apiUrl}/users/wallet-balance?walletType=` + walletType,
    );
  }

  selfieKyc(data: any) {
    return this.http.post(`${this.apiUrl}/kyc/create-selfie-request`, data);
  }

  saveSelfieVerification(data: any) {
    return this.http.post(`${this.apiUrl}/kyc/save-selfie-verification`, data);
  }

  createKycRequest(data: any) {
    return this.http.post(`${this.apiUrl}/kyc/create-kyc-request`, data);
  }

  updateFinancialDetails(data: any) {
    return this.http.post(
      `${this.apiUrl}/kyc/save-financial-information`,
      data,
    );
  }

  verifyBankAccount(data: any) {
    return this.http.post(`${this.apiUrl}/kyc/verify-bank`, data);
  }

  confirmBankAccount(data: any) {
    return this.http.post(`${this.apiUrl}/kyc/confirm-bank`, data);
  }

  revertKycStatus() {
    return this.http.get(`${this.apiUrl}/kyc/revert-status`);
  }

  verifyUpi(data: any) {
    return this.http.post(`${this.apiUrl}/kyc/verify-upi`, data);
  }

  getAllUpi() {
    return this.http.get(`${this.apiUrl}/kyc/get-upi`);
  }

  createDepositRequest(data: any) {
    return this.http.post(`${this.apiUrl}/users/deposit-request`, data);
  }

  getDeposits() {
    return this.http.get(`${this.apiUrl}/users/deposits`);
  }

  deleteSltp(data: any) {
    return this.http.post(`${this.orderEngineUrl}/orders/delete-sltp `, data);
  }

  resendOtp(data: any) {
    return this.http.post(`${this.apiUrl}/users/resend-otp`, data);
  }
}
